const alphaNum = {
  '0': 'A',
  '1': 'B',
  '2': 'C',
  '3': 'D',
  '4': 'E',
  '5': 'F',
  '6': 'G',
}

export default alphaNum


// WEBPACK FOOTER //
// ./src/helpers/alphaNum.js